<template>
    <div>
        <div class="d-flex justify-content-evenly notFound">
            <div class="col-md-6 card" style="margin-top: 50px;">
                <div class="d-flex bd-highlight mb-3 justify-content-evenly">
                    <div class="p-1 bd-highlight justify-content-center" style="text-align: center;">
                         <img src="../../../customer/assets/images/logo400.png" class="logo1" >
                          <h6 style="font-size: 10px;">گروه فناوری اطلاعات   </h6>
                    </div>
                </div>
                <div class="d-flex bd-highlight mb-3 justify-content-center">
                    <img src="../../../customer/assets/images/images404.svg " style="width: 30%;">
                </div>
                <div class="d-flex bd-highlight mb-3 justify-content-center">
                    <ul class="list-group p-2 list-group-flush">
                        <li class="list-item p-1" style="text-align: center;"><h5>صفحه مورد نظر شما وجود ندارد </h5></li>
                        <li class="list-item p-1"> <a href="/certificate" class="btn btn-outline-danger "> با کلیک بر روی متن میتوانید. وارد صفحه استعلام گواهینامه هلو آکادمی شوید </a></li>
                    </ul>
                </div>
                <div class="d-flex bd-highlight mb-3 justify-content-evenly">
                    <div class="p-2 bd-highlight">
                        <a href="https://holooacademy.com/" class="btn btn-danger">
                              <span style="font-size: 12px">بازگشت به سایت هلو اکادمی </span>
                            </a>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>


<script setup>
  import  url from "../../../../config/config.json"
  let back = $ref(url.REDIRECT);
</script>
